module.exports = __webpack_public_path__ + "static/img/tmg-logo.a1bfc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tmg-logo.png
// module id = QRpz
// module chunks = 1